module.exports = __webpack_public_path__ + "img/bg_pic6.2883ff2b.png";